import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../css/Home.css';
import Footer from './footer/Footer';
import Header from '../components/Header';
import GoogleReviews from './GoogleReviews';
import Faq from './Faq';
import site from '../data/site.json';
import { localBusinessSchema } from '../data/schema';

const Home = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    // Images du carrousel avec vos vraies photos
    const carouselImages = [
        {
            src: '/img/home/before_after_2026_september_deauville.png',
            alt: 'Débarras septembre 2026 Deauville Résidence Carol Parc',
            title: 'Septembre 2026, Deauville'
        },
        {
            src: '/img/home/before_after_2026_september_blonville.png',
            alt: 'Débarras septembre 2026 Blonville-sur-mer',
            title: 'Septembre 2026, Blonville-sur-Mer'
        },
        {
            src: '/img/home/before_after_2026_september_trouville.png',
            alt: 'Débarras septembre 2026 Trouville-sur-Mer',
            title: 'Septembre 2026, Trouville-sur-Mer'
        },
        {
            src: '/img/home/before_after_2026_august_villers.png',
            alt: 'Débarras août 2026 Villers-sur-Mer',
            title: 'Août 2026, Villers-sur-Mer'
        },
        {
            src: '/img/home/before_after_2026_may_deauville.png',
            alt: 'Débarras mai 2026 Deauville',
            title: 'Mai 2026, Deauville'
        },
        {
            src: '/img/home/before_after_2026_february_deauville.png',
            alt: 'Débarras février 2026 Deauville',
            title: 'Février 2026, Deauville'
        },
        {
            src: '/img/home/before_after_2026_january_deauville.png',
            alt: 'Débarras janvier 2026 Deauville',
            title: 'Janvier 2026, Deauville'
        },
        {
            src: '/img/home/before_after_2026_january_trouville.png',
            alt: 'Débarras janvier 2026 Trouville-sur-Mer',
            title: 'Janvier 2026, Trouville-sur-Mer'
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [carouselImages.length]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
    };
    
    return (
        <>
            <Helmet>
                <title>Débarras Deauville & Côte Fleurie, gratuit | CC Débarras 14</title>
                <meta name="description" content="Débarras de maisons, appartements, caves et greniers à Deauville, Trouville, Touques, Villers-sur-Mer et sur toute la Côte Fleurie. Gratuit si vos objets sont revendables, sinon devis gratuit. ☎ 07 67 56 72 54" />
                <link rel="canonical" href="https://ccdebarras14.fr/" />

                {/* Open Graph */}
                <meta property="og:title" content="CC Débarras 14 : débarras gratuit à Deauville et sur la Côte Fleurie" />
                <meta property="og:description" content="Débarras de maisons, appartements, caves et greniers. Succession, vente, départ en maison de retraite. 5/5 sur Google." />
                <meta property="og:url" content="https://ccdebarras14.fr/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://ccdebarras14.fr/img/home/cover.png" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="CC Débarras 14 : débarras gratuit à Deauville" />
                <meta name="twitter:description" content="Débarras de maisons, appartements, caves et greniers sur la Côte Fleurie." />

                <script type="application/ld+json">{JSON.stringify(localBusinessSchema())}</script>
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "CC Débarras 14",
                    "url": "https://ccdebarras14.fr/",
                    "inLanguage": "fr-FR",
                    "publisher": { "@id": "https://ccdebarras14.fr/#business" }
                })}</script>
            </Helmet>
            
            <Header />
            
            <div className="home-component">
                <div className="home-content">
                    {/* Hero Banner */}
                    <div className="home-hero-banner">
                        <div className="home-hero-logo">
                            <img 
                                src="/img/home/logo.png" 
                                alt="CC Débarras 14 Logo" 
                                className="home-hero-logo-img"
                            />
                        </div>
                        <div className="home-hero-image">
                            <img 
                                src="/img/home/cover.png" 
                                alt="CC Débarras 14 - Déménagement et débarras professionnel" 
                                className="home-hero-cover-img"
                            />
                        </div>
                    </div>

                    {/* Présentation */}
                    <div className="home-presentation-div">
                        <h1 className="home-presentation-title">Débarras professionnel à Deauville et sur la Côte Fleurie</h1>
                        <p>Un décès, une succession, un départ en maison de retraite, une vente, ou simplement du rangement ?</p>
                        <div>
                            <p><strong>Nous vous proposons de vous débarrasser gratuitement*</strong></p>
                        </div>
                        <div>
                            <p>ALORS, N'HÉSITEZ PLUS... APPELEZ NOUS !</p>
                            <div className="home-presentation-button-container">
                                <button 
                                    className="home-presentation-call-button"
                                    onClick={() => window.open('tel:0767567254')}
                                >
                                    <span><svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path opacity="0.5" d="M15.5562 14.5477L15.1007 15.0272C15.1007 15.0272 14.0181 16.167 11.0631 13.0559C8.10812 9.94484 9.1907 8.80507 9.1907 8.80507L9.47752 8.50311C10.1841 7.75924 10.2507 6.56497 9.63424 5.6931L8.37326 3.90961C7.61028 2.8305 6.13596 2.68795 5.26145 3.60864L3.69185 5.26114C3.25823 5.71766 2.96765 6.30945 3.00289 6.96594C3.09304 8.64546 3.81071 12.259 7.81536 16.4752C12.0621 20.9462 16.0468 21.1239 17.6763 20.9631C18.1917 20.9122 18.6399 20.6343 19.0011 20.254L20.4217 18.7584C21.3806 17.7489 21.1102 16.0182 19.8833 15.312L17.9728 14.2123C17.1672 13.7486 16.1858 13.8848 15.5562 14.5477Z" fill="#ffffff"></path> <path d="M13.2595 1.87983C13.3257 1.47094 13.7122 1.19357 14.1211 1.25976C14.1464 1.26461 14.2279 1.27983 14.2705 1.28933C14.3559 1.30834 14.4749 1.33759 14.6233 1.38082C14.9201 1.46726 15.3347 1.60967 15.8323 1.8378C16.8286 2.29456 18.1544 3.09356 19.5302 4.46936C20.906 5.84516 21.705 7.17097 22.1617 8.16725C22.3899 8.66487 22.5323 9.07947 22.6187 9.37625C22.6619 9.52466 22.6912 9.64369 22.7102 9.72901C22.7197 9.77168 22.7267 9.80594 22.7315 9.83125L22.7373 9.86245C22.8034 10.2713 22.5286 10.6739 22.1197 10.7401C21.712 10.8061 21.3279 10.53 21.2601 10.1231C21.258 10.1121 21.2522 10.0828 21.2461 10.0551C21.2337 9.9997 21.2124 9.91188 21.1786 9.79572C21.1109 9.56339 20.9934 9.21806 20.7982 8.79238C20.4084 7.94207 19.7074 6.76789 18.4695 5.53002C17.2317 4.29216 16.0575 3.59117 15.2072 3.20134C14.7815 3.00618 14.4362 2.88865 14.2038 2.82097C14.0877 2.78714 13.9417 2.75363 13.8863 2.7413C13.4793 2.67347 13.1935 2.28755 13.2595 1.87983Z" fill="#ffffff"></path> <path fillRule="evenodd" clipRule="evenodd" d="M13.4857 5.3293C13.5995 4.93102 14.0146 4.7004 14.4129 4.81419L14.2069 5.53534C14.4129 4.81419 14.4129 4.81419 14.4129 4.81419L14.4144 4.81461L14.4159 4.81505L14.4192 4.81602L14.427 4.81834L14.4468 4.8245C14.4618 4.82932 14.4807 4.8356 14.5031 4.84357C14.548 4.85951 14.6074 4.88217 14.6802 4.91337C14.8259 4.97581 15.0249 5.07223 15.2695 5.21694C15.7589 5.50662 16.4271 5.9878 17.2121 6.77277C17.9971 7.55775 18.4782 8.22593 18.7679 8.7154C18.9126 8.95991 19.009 9.15897 19.0715 9.30466C19.1027 9.37746 19.1254 9.43682 19.1413 9.48173C19.1493 9.50418 19.1555 9.52301 19.1604 9.53809L19.1665 9.55788L19.1688 9.56563L19.1698 9.56896L19.1702 9.5705C19.1702 9.5705 19.1707 9.57194 18.4495 9.77798L19.1707 9.57194C19.2845 9.97021 19.0538 10.3853 18.6556 10.4991C18.2607 10.6119 17.8492 10.3862 17.7313 9.99413L17.7276 9.98335C17.7223 9.96832 17.7113 9.93874 17.6928 9.89554C17.6558 9.8092 17.5887 9.66797 17.4771 9.47938C17.2541 9.10264 16.8514 8.53339 16.1514 7.83343C15.4515 7.13348 14.8822 6.73078 14.5055 6.50781C14.3169 6.39619 14.1757 6.32909 14.0893 6.29209C14.0461 6.27358 14.0165 6.26254 14.0015 6.25721L13.9907 6.25352C13.5987 6.13564 13.3729 5.72419 13.4857 5.3293Z" fill="#ffffff"></path> </g></svg></span>
                                    <span>07 67 56 72 54</span>
                                </button>
                            </div>
                        </div>
                        <div className="home-hero-disclaimer-quote">
                            <span>*Si rien n'est vendable nous établissons un devis pour l'enlèvement de vos affaires que nous trierons avant dépôt en déchetterie.</span>
                        </div>
                    </div>

                    {/* Nous débarrassons */}
                    <div className="home-we-clear-out-section">
                        <h2>Nous débarrassons :</h2>
                        <div className="home-we-clear-out-categories">
                            <div className="home-we-clear-out-category">
                                <h3>🏠 Résidentiel</h3>
                                <ul>
                                    <li>Maisons</li>
                                    <li>Appartements</li>
                                    <li>Caves</li>
                                    <li>Greniers</li>
                                </ul>
                            </div>
                            <div className="home-we-clear-out-category">
                                <h3>🏢 Professionnel</h3>
                                <ul>
                                    <li>Locaux professionnels</li>
                                    <li>Bureaux</li>
                                    <li>Entrepôts</li>
                                    <li>Garages</li>
                                </ul>
                            </div>
                            <div className="home-we-clear-out-category">
                                <h3>🏗️ Autres espaces</h3>
                                <ul>
                                    <li>Hangars</li>
                                    <li>Débarras</li>
                                    <li>Combles</li>
                                    <li>Sous-sols</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Nos derniers débarras */}
                    <div className="home-our-latest-clearances-section">
                        <h2>Nos derniers débarras</h2>
                        <div className="home-our-latest-clearances-carousel-container">
                            <div className="home-our-latest-clearances-carousel-wrapper">
                                <button className="home-our-latest-clearances-carousel-button" onClick={prevSlide}>
                                    ❮
                                </button>
                                
                                <div className="home-our-latest-clearances-carousel-content">
                                    <img 
                                        src={carouselImages[currentSlide].src} 
                                        alt={carouselImages[currentSlide].alt}
                                        className="home-our-latest-clearances-carousel-image"
                                    />
                                    <div className="home-our-latest-clearances-carousel-title">
                                        {carouselImages[currentSlide].title}
                                    </div>
                                </div>
                                
                                <button className="home-our-latest-clearances-carousel-button" onClick={nextSlide}>
                                    ❯
                                </button>
                            </div>
                            
                            <div className="home-our-latest-clearances-carousel-indicators">
                                {carouselImages.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`home-our-latest-clearances-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
                                        onClick={() => setCurrentSlide(index)}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="home-see-all-clearances-link-container">
                            <Link to="/avant-apres" className="home-see-all-clearances-link">
                                Voir tous les débarras →
                            </Link>
                        </div>
                    </div>

                    {/* Nos plateformes de vente */}
                    <div className="home-our-sales-platforms-section">
                        <div className="home-our-sales-platforms-header">
                            <h2>Nos plateformes de vente</h2>
                            <p>Découvrez nos objets récupérés et remis à neuf</p>
                        </div>
                        
                        <div className="home-our-sales-platforms-cards">
                            <a 
                                href="https://www.leboncoin.fr/profil/1e232eb3-f01f-4e80-9599-e563135a8218/offres" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="home-our-sales-platforms-card"
                            >
                                <div className="home-our-sales-platforms-card-header">
                                    <div className="home-our-sales-platforms-logo-leboncoin">
                                        <img src="/img/home/leboncoin.png" alt="Leboncoin Logo" />
                                    </div>
                                    <div className="home-our-sales-platforms-badge">Populaire</div>
                                </div>
                                <div className="home-our-sales-platforms-card-content">
                                    <h3>Leboncoin</h3>
                                    <p>Meubles, électroménager, objets de décoration et bien plus encore</p>
                                    <div className="home-our-sales-platforms-stats">
                                        <span className="home-our-sales-platforms-stat">
                                            <strong>Livraison</strong> possible (10km)
                                        </span>
                                        <span className="home-our-sales-platforms-stat">
                                            <strong>5/5</strong> avis clients
                                        </span>
                                    </div>
                                </div>
                                <div className="home-our-sales-platforms-card-footer">
                                    <span className="home-our-sales-platforms-see-our-ads">Voir nos annonces →</span>
                                </div>
                            </a>

                            <a 
                                href="https://www.facebook.com/marketplace/profile/100083841056627/?ref=permalink" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="home-our-sales-platforms-card"
                            >
                                <div className="home-our-sales-platforms-card-header">
                                    <div className="home-our-sales-platforms-logo-facebook">
                                        <img src="/img/home/facebook.png" alt="Facebook Logo" />
                                    </div>
                                    <div className="home-our-sales-platforms-badge home-our-sales-platforms-facebook-badge">Récent</div>
                                </div>
                                <div className="home-our-sales-platforms-card-content">
                                    <h3>Facebook Marketplace</h3>
                                    <p>Articles tendance et pièces uniques dénichées lors de nos débarras</p>
                                    <div className="home-our-sales-platforms-stats">
                                        <span className="home-our-sales-platforms-stat">
                                            <strong>Livraison</strong> possible (10km)
                                        </span>
                                    </div>
                                </div>
                                <div className="home-our-sales-platforms-card-footer">
                                    <span className="home-our-sales-platforms-see-our-ads">Voir nos annonces →</span>
                                </div>
                            </a>
                        </div>
                        
                        <div className="home-our-sales-platforms-info">
                            <div className="home-our-sales-platforms-info-card">
                                <div className="home-our-sales-platforms-info-icon">♻️</div>
                                <div>
                                    <h4>Économie circulaire</h4>
                                    <p>Chaque objet récupéré trouve une seconde vie</p>
                                </div>
                            </div>
                            <div className="home-our-sales-platforms-info-card">
                                <div className="home-our-sales-platforms-info-icon">💰</div>
                                <div>
                                    <h4>Prix attractifs</h4>
                                    <p>Des objets de qualité à prix réduits</p>
                                </div>
                            </div>
                            <div className="home-our-sales-platforms-info-card">
                                <div className="home-our-sales-platforms-info-icon">🏠</div>
                                <div>
                                    <h4>Ventes à domicile</h4>
                                    <p>2 ventes à domicile par an</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <GoogleReviews />

                    <Faq items={site.faq} />
                    
                    {/* Nos partenaires */}
                    <div className="home-our-partners-section">
                        <div className="home-our-partners-header">
                            <h2>Nos partenaires</h2>
                            <p>Professionnels de l'immobilier et collectivités qui font appel à nos services</p>
                        </div>
                        
                        <Slider
                            slidesToShow={4}
                            slidesToScroll={1}
                            autoplay={true}
                            autoplaySpeed={2000}
                            arrows={false}
                            dots={false}
                            pauseOnHover={false}
                            infinite={true}
                            responsive={[
                                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                                { breakpoint: 768, settings: { slidesToShow: 2 } },
                                { breakpoint: 480, settings: { slidesToShow: 1 } }
                            ]}
                        >
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://fr.foncia.com/agence-immobiliere/deauville-14800/agence-immobiliere/foncia-normandie-2816" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/foncia_deauville.png" alt="Foncia Deauville"/>
                                </a>
                            </div>
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://www.citya.com/agences-immobilieres/deauville-14800/259" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/citya_deauville.png" alt="Citya Immobilier Deauville"/>
                                </a>
                            </div>
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://www.immo14-touques.fr/" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/immo_14.png" alt="Immo 14" className="partner-logo-large"/>
                                </a>
                            </div>
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://www.mairiedetouques.fr/" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/ville_de_touques.png" alt="Mairie de Touques" className="partner-logo-large"/>
                                </a>
                            </div>
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://www.hexadebarras.com/" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/hexa_debarras.jpeg" alt="Hexas Débarras"/>
                                </a>
                            </div>
                            <div className="home-our-partners-carousel-slide">
                                <a href="https://3gimmo.com/" target="_blank" rel="noopener noreferrer" className="home-our-partners-link">
                                    <img src="/img/home/3g_immo.png" alt="3G Immo"/>
                                </a>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
            
            <Footer />
        </>
    );
};

export default Home;